import { format } from 'date-fns';

export const FPS_OPTIONS = {
  chart: {
    id: 'fpsGraph',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'FPS stats',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'FPS',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const INTERFACE_OPTIONS = {
  chart: {
    id: 'ethGraph',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'Network interface bandwidth',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'bandwidth',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const CLIENT_BITRATE_OPTIONS = {
  chart: {
    id: 'clientBitrateGraph',
    height: 350,
    type: 'area',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'Client bitrate',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'bitrate',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const FRAME_SIZE_OPTIONS = {
  chart: {
    id: 'frameSize',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'stepline',
    width: 2.5,
  },
  title: {
    text: 'Frame size',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'height',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const FIR_PLI_NACK_OPTIONS = {
  chart: {
    id: 'firPliNack',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'firCount pliCount and nackCount',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'count',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const QUALITY_LIMITATION_OPTIONS = {
  chart: {
    id: 'qualityLimitation',
    height: 350,
    type: 'stepline',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'Quality limitation reason',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    title: {
      text: 'Quality limitation reason',
    },
    labels: {
      formatter(value) {
        if (value === 0) {
          return 'None';
        }
        if (value === 1) {
          return 'Cpu';
        }
        if (value === 2) {
          return 'Bandwidth';
        }
        return 'Other';
      },
    },
    min: 0,
    max: 3,
    decimalsInFloat: 0,
    tickAmount: 3,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const INBOUND_FPS_OPTIONS = {
  chart: {
    id: 'inboundFpsGraph',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'FPS stats',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'FPS',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const INBOUND_BITRATE_OPTIONS = {
  chart: {
    id: 'inboundBitrateGraph',
    height: 350,
    type: 'area',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'Bitrate',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'bitrate',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const INBOUND_FRAME_SIZE_OPTIONS = {
  chart: {
    id: 'inboundFrameSize',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'stepline',
    width: 2.5,
  },
  title: {
    text: 'Frame size',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'height',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const INBOUND_FIR_PLI_NACK_OPTIONS = {
  chart: {
    id: 'inboundFirPliNack',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'firCount pliCount and nackCount',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'count',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const INBOUND_INTERFACE_OPTIONS = {
  chart: {
    id: 'inboundEthGraph',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'Network interface bandwidth',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'bandwidth',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const CPU_OPTIONS = {
  chart: {
    id: 'cpuGraph',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'CPU stats',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'Usage in percentage',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const GPU_OPTIONS = {
  chart: {
    id: 'gpuGraph',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'GPU stats',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'Usage in percentage',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const MEMORY_OPTIONS = {
  chart: {
    id: 'memoryGraph',
    height: 350,
    type: 'area',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'Memory stats',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',
    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'Memory in MB',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const FILE_OPTIONS = {
  chart: {
    id: 'openFilesGraph',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'Open files and DMA buf count',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'count',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const QOS_FPS_GRAPH = {
  chart: {
    id: 'qosFpsGraph',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'Fps stats',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    decimalsInFloat: 2,
    title: {
      text: 'fps',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const QOS_BITRATE_GRAPH = {
  chart: {
    id: 'qosBitrateGraph',
    height: 350,
    type: 'area',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'Average bitrate',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    decimalsInFloat: 2,
    title: {
      text: 'bitrate',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const QOS_ERROR_GRAPH = {
  chart: {
    id: 'qosErrorGraph',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'stepline',
    width: 2.5,
  },
  title: {
    text: 'Error bit',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'error bit',
    },
    min: 0,
    max: 1,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const EMC_FREQUENCY_OPTIONS = {
  chart: {
    id: 'emcFrequencyGraph',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'EMC frequency stats',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'value in percentage',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};

export const ENC_DEC_FREQUENCY_OPTIONS = {
  chart: {
    id: 'encDecFrequencyGraph',
    height: 350,
    type: 'line',
    animations: {
      enabled: true,
      easing: 'linear',
      dynamicAnimation: {
        speed: 500,
      },
    },
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
    width: 2.5,
  },
  title: {
    text: 'ENC DEC frequency stats',
    align: 'left',
  },
  markers: {
    size: 0,
  },
  xaxis: {
    type: 'numeric',

    labels: {
      formatter(value) {
        return format(new Date(value), 'MM/dd HH:mm:ss');
      },
    },
  },
  yaxis: {
    forceNiceScale: true,
    title: {
      text: 'value in MHz',
    },
    min: 0,
  },
  legend: {
    position: 'top',
    horizontalAlign: 'right',
    floating: true,
    offsetY: -25,
    offsetX: -5,
  },
};
